import type Combatant from "@/encounter/model/Combatant.ts";

export const combatantsOnLevel = (combatants: Combatant[], levelId?: string) =>
    levelId ? combatants.filter(combatant => combatant.levelId === levelId) : combatants;
